import { PrimeIcons } from "primereact/api";
import { Button } from "primereact/button";
import { Menu } from "primereact/menu";

import {
  labelDelete,
  labelUpdate,
  modalConfirmDeleteDataSourceSubtitlePart1,
  modalConfirmDeleteDataSourceSubtitlePart2,
  snackbarDataDeleted,
  snackbarSeverityInfo,
  snackbarSourceNotReady,
  snackbarSummarySourceAddSuccessSubTitlePart1,
  snackbarSummarySourceDeleteSuccessSubTitlePart2,
} from "_constants";
import { ModalPrivateSource } from "components/modals";
import { useConfirmDialogExit } from "hooks";
import { useSnackbar } from "providers/SnackbarProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { deleteSource, getDetailSource, getStateSource } from "services";
import { setSource } from "store/slicer/GestioneSourceSlice";
import { setPageSources } from "store/slicer/GestioneSourcesSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { DetailPanelContext } from "providers/DetailPanelProvider";

export const SourceTableRowButtonActions = ({ source }: { source?: any }) => {
  const dispatch = useAppDispatch();
  const [detailSource, setDetailSource] = useState<any>();
  const [showModalPrivateSource, setShowModalPrivateSource] = useState(false);
  const { showSnackbar } = useSnackbar();
  const currentSource = useAppSelector(
    (state) => state.gestioneSourcesSlice.currentSource
  );
  const { showConfirmDialogDelete } = useConfirmDialogExit();
  const { hidePanel } = useContext(DetailPanelContext);
  useEffect(() => {}, [currentSource]);

  const menuRight = useRef<any>(null);
  const items = [
    {
      label: labelUpdate,
      icon: PrimeIcons.PENCIL,
      command: () => {
        getStateSource((source ?? currentSource).id)
          .then((res) => {
            if (res.data.elaborated) {
              getDetailSource((source ?? currentSource).id)
                .then((res) => {
                  dispatch(setSource(res.data));
                  setDetailSource(res.data);
                  setShowModalPrivateSource(true);
                })
                .catch((_) => {});
            } else {
              showSnackbar({
                severity: snackbarSeverityInfo,
                summary: snackbarSeverityInfo,
                detail: snackbarSourceNotReady,
                life: 5000,
              });
            }
          })
          .catch((_) => {});
      },
    },
    {
      label: labelDelete,
      icon: PrimeIcons.TRASH,
      className: "p-menu-item-custom delete-color",
      command: () => {
        getStateSource((source ?? currentSource).id)
          .then((res) => {
            if (res.data.elaborated) {
              showConfirmDialogDelete({
                subtitle: `${modalConfirmDeleteDataSourceSubtitlePart1}<span class="font-weight-700">${
                  (source ?? currentSource).name
                }</span>${modalConfirmDeleteDataSourceSubtitlePart2}`,
                rejectCallback: callDeleteSource,
              });
            } else {
              showSnackbar({
                severity: snackbarSeverityInfo,
                summary: snackbarSeverityInfo,
                detail: snackbarSourceNotReady,
                life: 5000,
              });
            }
          })
          .catch((_) => {});
      },
    },
  ];

  const callDeleteSource = () => {
    deleteSource((source ?? currentSource).id)
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarDataDeleted,
          detail: `${snackbarSummarySourceAddSuccessSubTitlePart1}${
            (source ?? currentSource).name
          }${snackbarSummarySourceDeleteSuccessSubTitlePart2}`,
          life: 5000,
        });
        dispatch(setPageSources(-1));
        setTimeout(() => {
          dispatch(setPageSources(1));
          hidePanel();
        }, 200);
      })
      .catch((_) => {});
  };

  return (
    <>
      <Menu
        model={items}
        popup
        ref={menuRight}
        id="popup_menu_right"
        className="p-menu-custom-logout"
        popupAlignment="right"
      />
      <Button
        icon={PrimeIcons.ELLIPSIS_V}
        text
        severity="secondary"
        onClick={(event) => menuRight?.current?.toggle(event)}
        className="width-px-28 height-px-28"
      />
      {showModalPrivateSource && (
        <ModalPrivateSource
          source={detailSource}
          modalVisibile={showModalPrivateSource}
          onClose={() => setShowModalPrivateSource(false)}
          isPrivate={false}
        />
      )}
    </>
  );
};
